import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { secondaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock8Props extends ComponentPropsWithRef<"div"> {
  buttons: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock8 = forwardRef<HTMLDivElement, HomepageBlock8Props>(
  ({ header, buttons, footer, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: secondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-gap-6 md:wb-gap-10 wb-flex wb-flex-col">
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-gap-2 md:wb-gap-6 wb-text-center">
                  {header}
                </BlockSection.NestedBlock>
                <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-9">
                  <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-flex-row md:wb-items-center">
                    {buttons}
                  </BlockSection.NestedBlock>
                  {footer}
                </div>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock8.displayName = "HomepageBlock8";
